/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { Fragment, useContext } from "react";
import { isArrayEmpty } from "utils/empty-exists";
import { ContentZoneContext } from "cms/components/context";
import { EmptyContentMessage } from "cms/components/layout/empty/empty-content-message";
import { LinkButtonItemDisplay } from "./link-button";

const LinkButtonComponentDisplay = () => {

    const linkButtonComponentContext = useContext(ContentZoneContext);
    const component = linkButtonComponentContext?.component;
    const buttonList = component?.button_list ?? [];
    const hasContent = !isArrayEmpty(buttonList);

    return (
        <Fragment>
            <EmptyContentMessage hasContent={hasContent} component={component} />
            {hasContent && (
                <Fragment>
                    <div className='simplicity-linkbutton-container'>
                        {
                            buttonList.map((item, index) => (
                                <LinkButtonItemDisplay
                                    key={index}
                                    item={item}
                                />
                            ))
                        }
                    </div>
                </Fragment>
            )}
        </Fragment>
    );
};


LinkButtonComponentDisplay.displayName = "LinkButtonComponentDisplay";
export { LinkButtonComponentDisplay };
